import { createContext } from 'react'
export const PartsTableContext = createContext()
